"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Robot = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Robot"));

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var errorStyle = process.env.NODE_ENV === "production" ? {
  name: "1hqzxpk-errorStyle",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;;label:errorStyle;"
} : {
  name: "1hqzxpk-errorStyle",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;;label:errorStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Rpc3BsYXlzL0Vycm9yRGlzcGxheS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXNCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Rpc3BsYXlzL0Vycm9yRGlzcGxheS5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgUm9ib3QgZnJvbSAnQGNpbXByZXNzL3JlYWN0LWNvbXBvbmVudHMvbGliL3NoYXBlcy9Sb2JvdCc7XG5cbmNvbnN0IGVycm9yU3R5bGUgPSBjc3NgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuYDtcblxuY29uc3QgRXJyb3JEaXNwbGF5ID0gKHsgZXJyb3JNc2cgfSkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT1cInJvYm90XCIgY3NzPXtlcnJvclN0eWxlfT5cbiAgICA8Um9ib3Qgc3RhdHVzPVwiZGFuZ2VyXCIgLz5cbiAgICA8cD57ZXJyb3JNc2d9PC9wPlxuICAgIDxwPlxuICAgICAgSWYgdGhlIGlzc3VlIHBlcnNpc3RzLCBjb250YWN0IDxhIGhyZWY9XCJtYWlsdG86cGxhdGZvcm1zdXBwb3J0QGNpbXByZXNzLmNvbVwiPnBsYXRmb3Jtc3VwcG9ydEBjaW1wcmVzcy5jb208L2E+IGZvclxuICAgICAgc3VwcG9ydC5cbiAgICA8L3A+XG4gIDwvZGl2PlxuKTtcblxuRXJyb3JEaXNwbGF5LnByb3BUeXBlcyA9IHtcbiAgZXJyb3JNc2c6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEVycm9yRGlzcGxheTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ErrorDisplay = function ErrorDisplay(_ref) {
  var errorMsg = _ref.errorMsg;
  return (0, _core.jsx)("div", {
    className: "robot",
    css: errorStyle
  }, (0, _core.jsx)(_Robot["default"], {
    status: "danger"
  }), (0, _core.jsx)("p", null, errorMsg), (0, _core.jsx)("p", null, "If the issue persists, contact ", (0, _core.jsx)("a", {
    href: "mailto:platformsupport@cimpress.com"
  }, "platformsupport@cimpress.com"), " for support."));
};

ErrorDisplay.propTypes = {
  errorMsg: _propTypes["default"].string.isRequired
};
var _default = ErrorDisplay;
exports["default"] = _default;